import client from '@apis/client';

export const clientOption = () => {
  return client.post('/shopl-chat/basic/client/option');
};
